import { IReviewQuote, ViewValues } from '@sapientpro/sapientpro-data-models';
import classnames from 'classnames';
import { useAtomValue } from 'jotai';
import Link from 'next/link';
import Img from '../../../../../components/Img';
import { theme } from '../../../../../store/theme';
import styles from './ReviewsTextSlide.module.scss';
import ClutchStars from '../../../../../components/ClutchStars/ClutchStars';

type ReviewsTextSlideProps = {
  review: IReviewQuote,
  className?: string,
  view: ViewValues
};
const ReviewsTextSlide = ({ review, className, view }: ReviewsTextSlideProps) => {
  const appTheme = useAtomValue(theme);

  return (
    <div className={classnames(styles.slide, styles[`${view}-view`], className)}>
      <div className={styles.slide__content}>
        <div className={styles.author}>
          <div className={styles.author__avatar}>
            <Img
              src={review.author.avatar.url}
              alt={review.author.avatar.alternativeText || review.author.name}
              withPreloader
            />
          </div>
          <div className={styles.author__info}>
            <p className={styles.author__name}>{review.author.name}</p>
            <p className={styles.author__description}>{review.author.position}</p>
          </div>
          {review.reviewLink && (
            <Link
              href={review.reviewLink}
              target='_blank'
              className={styles.author__clutch}
              rel='noreferrer'
            >
              <Img
                src={`/media/clutch_${appTheme}.svg`}
                alt='clutch'
                width={43}
                height={12}
                className={styles.logo}
              />
              Based
            </Link>
          )}
        </div>
        <p className={styles.text}>{review.feedBack}</p>
        <div className={styles.reviewStars}>
          <ClutchStars filledCount={5} />
        </div>
      </div>
    </div>
  );
};

export default ReviewsTextSlide;
